const vpcCidrList = [
    '10.1.0.0/16',
    '10.129.240.0/21',
    '10.214.64.0/18',
    '10.40.0.0/16',
    '10.0.0.0/16',
    '10.80.114.0/23',
    '10.80.44.0/22',
    '10.67.16.0/21',
    '10.224.0.0/20',
    '10.0.0.0/21',
    '172.31.0.0/16',
    '10.0.0.0/18',
    '10.164.128.0/18',
    '10.0.0.0/18',
    '10.119.24.0/21',
    '10.70.60.0/22',
    '10.119.24.0/21',
    '10.254.254.0/24',
    '10.67.218.0/23',
    '10.85.176.0/21'
  ];
  
  export default vpcCidrList;